import React from 'react';
import { StyleSheet, Text, View, ViewStyle} from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  textContent: string;
  boxContent: any;
  resultBoxStyle?: ViewStyle;
}

export const BodyscaleResultBoxAndText = ({
  textContent,
  boxContent,
  resultBoxStyle,
}: IProps) => {
  return (
    <>
      <View style={[styles.resultBox, resultBoxStyle]}>
        {boxContent}
      </View>
      <Text style={styles.descriptionText}>{textContent}</Text>
    </>
  );
};

const styles = StyleSheet.create({
  resultBox: {
    width: defaultScale(125),
    height: defaultScale(108),
    borderWidth: defaultScale(1),
    borderColor: Theme.GREY_FIGMA_LIGHT,
    marginVertical: defaultScale(17),
    justifyContent: 'center',
    alignItems: 'center',
  },
  descriptionText: {
    ...Theme.textStyle.small,
    textAlign: 'center',
  },
});
